<template>
    <div class="bg-danger text-white text-center p-2 text-uppercase">
        Attenzione! Applicazione in fase di implementazione ad uso esclusivo interno
    </div>
</template>

<script>
export default {
  name: 'WarningImplementation'
}
</script>



// WEBPACK FOOTER //
// src/front/components/common/WarningImplementation.vue